import { sendToApi } from 'api/client'
import { TierLimits } from './TierUsageClient'
import { AutopilotPlan, VirtualMarketerPlan } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/types'

export enum PaymentPlanKey {
  TeamTier = 'team_tier',
  ProTier = 'pro_tier',
  Team = 'team', // Deprecated
  Pro = 'pro', // Deprecated
  Free = 'free',
  EarlyAdopter = 'early-adopter',
  Enterprise = 'enterprise',
  BlazeCreator = 'blaze_creator',
  BlazeTeam = 'blaze_team',
  BlazeBusiness = 'blaze_business',
  BlazePro = 'blaze_pro',
  BlazeAgency = 'blaze_agency',
  BlazeEnterprise = 'blaze_enterprise',
  VirtualMarketer = 'virtual_marketer',
  BlazeAutopilotStarter = 'blaze_autopilot_starter',
  BlazeAutopilotGrowth = 'blaze_autopilot_growth',
  BlazeAutopilotEnterprise = 'blaze_autopilot_enterprise',
  BlazeAutopilotContentCredits = 'blaze_autopilot_content_credits',
  BlazeAutopilotWhiteLabel = 'blaze_autopilot_white_label',
  BlazeAutopilotChannels = 'blaze_autopilot_channels',
  BlazeAutopilotExtraAccounts = 'blaze_autopilot_extra_accounts',
}

export const legacyPricingKeys = [PaymentPlanKey.Free, PaymentPlanKey.Team, PaymentPlanKey.Pro]
export const updatedPricingKeys = [
  PaymentPlanKey.Free,
  PaymentPlanKey.TeamTier,
  PaymentPlanKey.ProTier,
  PaymentPlanKey.Enterprise,
]

export interface Price {
  price_id: string
  unit_amount: number
  coupon_id?: string
  amount_off?: number
}

interface Additional {
  amount_per_unit?: number
  plan_limit?: number
  monthly_price?: number
  yearly_price?: number
}

export interface PaymentPlan {
  id: number | undefined
  name: string
  key: PaymentPlanKey
  price: {
    month: Price
    year: Price
  }
  member_limit: number | undefined
  member_minimum: number | undefined
  doc_limit: number | undefined
  additionals?: {
    ai_words?: Additional
    plagiarism_checks?: Additional
    seats?: Additional
  }
  base_price_meta: TierLimits
}

export const fetchPaymentPlans = () => {
  return sendToApi<{ payment_plans: PaymentPlan[] }>('/payment_plans', {
    method: 'GET',
  })
}

export const fetchVirtualMarketerPlan = () => {
  return sendToApi<{ plan: VirtualMarketerPlan }>('/payment_plans/virtual_marketer_plan', {
    method: 'GET',
  })
}

export const fetchAutopilotPlans = () => {
  return sendToApi<{ plans: AutopilotPlan[] }>('/payment_plans/autopilot', {
    method: 'GET',
  })
}

export const fetchAutopilotAddOns = () => {
  return sendToApi<{ add_ons: AutopilotPlan[] }>('/payment_plans/autopilot_add_ons', {
    method: 'GET',
  })
}
